import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function contablecuentaComboReducer(state= initialState.contablecuentaCombo, action){
	switch(action.type){
		case types.GET_CONTABLECUENTAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}